$("#sideMenuBrand").click(function(){
    $(this).addClass("selected");
    $("#sideMenuIngredient").removeClass("selected");
    $("#sideMenuProduct").removeClass("selected");
});

$("#sideMenuIngredient").click(function(){
    $(this).addClass("selected");
    $("#sideMenuBrand").removeClass("selected");
    $("#sideMenuProduct").removeClass("selected");
});

$("#sideMenuProduct").click(function(){
    $(this).addClass("selected");
    $("#sideMenuBrand").removeClass("selected");
    $("#sideMenuIngredient").removeClass("selected");
});

$("#sideMenuClose").click(function(){
    $("#snMenu").removeClass("active");
});

$("#mobileSideMenuOpen").click(function(){
    $("#snMenu").addClass("active");
});


